import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import PayinList from "./components/PayinList";
import AddBatchFile from "./components/AddBatchFile";
import { getPayin } from "api/graphQL_crypto";

export interface PayoutRowObj {
  id: any; createdAt: any; batchId: any; clientId: any; clientName: any;
  gatewayId: any; gatewayName: any; totalTransactions: any; gateway: any;
  totalAmount: any; currency: any; transations: any;
}

const CryptoPayin = () => {
  const [page, setPage] = useState<number>(1);
  const [payouts, setPayouts] = useState<PayoutRowObj[]>([]);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { singleRoleData, setFilter, filter } = useContext(ClientContext);
  const location = useLocation();
  const [localFilters, setLocalFilters] = useState<any>({});
  const [clearClicked, setClearClick] = useState(0);

  const fetchPayouts = () => {
    let finalSearchText = "";
    if (location.state?.search) {
      finalSearchText = location.state.search;
      window.history.replaceState({}, document.title);
    } else {
      finalSearchText = searchTexts;
    }
    if (pageSize === null || pageSize === undefined) { setIsLoading(false); return; }
    setIsLoading(true);
    getPayin({ page, per_page: pageSize, searchTexts: finalSearchText })
      .then((data: any) => {
        if (data.status === "Error") {
          setPayouts([]); setTotalPage(1); setTotalItems(1); setCurrentPage(1);
        } else {
          setPayouts(data?.[0]);
          setTotalPage(data?.[1].total_pages);
          setTotalItems(data?.[1].total_items);
          setCurrentPage(data?.[1].current_page);
        }
      })
      .catch(() => { setPayouts([]); setIsLoading(false); })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => { fetchPayouts(); }, [page, pageSize, searchTexts, clearClicked]);
  useEffect(() => { setPageSize(50); }, [searchTexts]);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt); setPage(1); setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  const onClearClick = () => setClearClick((prev) => prev + 1);

  return (
    <div className="cpi-root">
      {/* Page header */}
      <div className="cpi-page-header">
        <div className="cpi-title-block">
          <div className="cpi-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
              <polyline points="17 6 23 6 23 12"/>
            </svg>
          </div>
          <div>
            <h1 className="cpi-heading">Crypto Payin</h1>
            <p className="cpi-sub">Manage incoming cryptocurrency batch payin transactions</p>
          </div>
        </div>
      </div>

      <PayinList
        tableData={payouts}
        fetchPayouts={fetchPayouts}
        isLoading={isLoading}
        roleData={singleRoleData}
        onValueChange={serchboxValueChange}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        setLocalFilters={setLocalFilters}
        filterData={fetchPayouts}
        localFilters={localFilters}
        filter={filter}
        setFilter={setFilter}
        setClearClick={onClearClick}
        fetchPayoutsForBatch={fetchPayouts}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .cpi-root { font-family:'Plus Jakarta Sans',sans-serif; display:flex; flex-direction:column; gap:20px; }
        .cpi-page-header { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:16px; }
        .cpi-title-block { display:flex; align-items:center; gap:14px; }
        .cpi-page-icon { width:44px; height:44px; border-radius:12px; background:linear-gradient(135deg,#faf5ff,#ede9fe); border:1.5px solid #ddd6fe; display:flex; align-items:center; justify-content:center; color:#7c3aed; flex-shrink:0; }
        .cpi-heading { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-0.4px; margin-bottom:2px; line-height:1.2; }
        .cpi-sub { font-size:13px; color:#94a3b8; font-weight:500; }
      `}</style>
    </div>
  );
};

export default CryptoPayin;